import React from 'react';
import Gallery, { PhotoProps } from 'react-photo-gallery';
import ArticleComponentCredits from './ArticleComponentCredits';
import Carousel, { Modal, ModalGateway } from 'react-images';
import ReactHtmlParser from 'react-html-parser';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

interface ExtendedPhotoProps extends PhotoProps {
  caption: string;
  credit: string;
}

interface GalleryWithLightBoxProps {
  photos: ExtendedPhotoProps[];
  caption: string;
  credit: string;
  creditLink: string;
}

export default function GalleryWithLightBox({ photos, caption, credit, creditLink }: GalleryWithLightBoxProps) {
  const [lightBoxImageIndex, setLightBoxImageIndex] = React.useState<number>(-1);
  const isMd = useBreakpoint(Breakpoint.MD);

  function onGalleryPhotoClicked(_: React.MouseEvent, photos: { index: number }) {
    setLightBoxImageIndex(photos.index);
  }

  return (
    <div className="gallery-wrapper">
      <Gallery
        photos={photos.map(photo => ({
          key: photo.key,
          src: photo.src,
          //srcSet: photo.srcSet,
          width: photo.width,
          height: photo.height,
          alt: photo.alt,
        }))}
        columns={2}
        margin={isMd ? 10 : 4}
        onClick={onGalleryPhotoClicked}
        direction={'column'}
      />
      <ArticleComponentCredits caption={caption} credit={credit} creditLink={creditLink} />

      {lightBoxImageIndex >= 0 && (
        <ModalGateway>
          <Modal
            onClose={() => setLightBoxImageIndex(-1)}
            styles={{
              // TODO: remove eslint-disable-next-line
              // eslint-disable-next-line
              blanket: (base: any) => ({
                ...base,
                zIndex: '9999999998 !important', // cover even the intercom button
              }),
              // TODO: remove eslint-disable-next-line
              // eslint-disable-next-line
              positioner: (base: any) => ({
                ...base,
                zIndex: '9999999999 !important',
              }),
              /*footer: (base: any) => ({  // FIXME: why isn't this working - Roland TODO
                ...base,
                fontFamily: 'Roboto',
              }),*/
            }}
          >
            <Carousel
              currentIndex={lightBoxImageIndex}
              views={photos.map(photo => ({
                key: photo.key,
                source: photo.src,
                //srcset: photo.srcSet,
                alt: photo.alt,
                caption: (
                  <div>
                    {photo.caption && <span>{photo.caption}</span>}
                    {photo.caption && photo.credit && <span> - </span>}
                    {photo.credit && ReactHtmlParser(photo.credit)}
                  </div>
                ),
              }))}
            />
          </Modal>
        </ModalGateway>
      )}
    </div>
  );
}
